<template>
    <div class="settlement-edc-content">
        <SOSlotBase :container-name="'settlement-edc-list-content'" :bg-grey="true" :is-search="search.onSearch">
            <template v-slot:title-bar>
                <SOTitleBar
                    :page-title="'Settlement EDC'"
                    :type="'back'"
                    @back="back"
                    :show-search="true"
                    @search="onOpenSearch"
                    v-if="!search.onSearch"
                />
            </template>
            <template v-slot:search-bar>
                <SOSearchBar
                    v-if="search.onSearch"
                    :context="'Transaksi'"
                    :placeholder="`Ketik minimal 2 karakter`"
                    :value="search.key"
                    :data-count="countDataSearch"
                    :search-information="`nominal settlement, waktu settlement, akun settlement & nama pembuat`"
                    :waiting="search.searching"
                    @do-search="doSearch"
                    @loading="onLoadingSearch"
                    @close="onCloseSearch"
                />
            </template>
            <template v-slot:empty-state>
                <div>
                    <SOEmptyState
                        v-if="!totalSettlementEdc && !isFetching && !search.onSearch"
                        :message="'Belum Pernah Settlement'"
                        :subMessage="'Riwayat settlement akan tampil disini.'"
                    />
                    <SOEmptySearchState
                        v-if="!totalSettlementEdc && !isFetching && search.onSearch && search.key.length > 1"
                        @action="resetSearchFilter"
                    />
                </div>
            </template>
            <template v-slot:skeleton v-if="isFetching && !isLoadMore">
                <div class="p-x-20 p-y-16 w-limit">
                    <CardSkeleton v-if="!search.onSearch" />
                    <SOLoadSearch v-if="search.onSearch" />
                </div>
            </template>
            <template v-slot:content>
                <div v-if="totalSettlementEdc && (isMinExport || !isExporting)">
                    <SOExportProgressMinimized
                        v-if="isMinExport"
                        :processed-data="exportProgress.processed"
                        :total-data="exportProgress.total"
                        :context="'Transaksi Reguler'"
                        :tracker-actions="`${modulName}/exportTracker`"
                        @on-success="checkExport"
                        @on-error="exportFail"
                    />
                    <SOExportMultipleFile
                        v-if="isMultipleExport"
                        :export-data="dataExport"
                        :export-data-length="dataLength"
                        :delete-cluster-actions="`${modulName}/exportDeleteCluster`"
                        :delete-master-actions="`${modulName}/exportDeleteMaster`"
                        @downloaded="(index) => { dataExport[index].downloaded = true }"
                        @done="finishExport"
                    />
                </div>
                <div class="">
                    <div class="p-x-20 bg-white p-y-8" v-if="totalSettlementEdc">
                        <p class="m-d-0">Mesin: {{ detailMesin.nama_mesin_edc }} • {{ detailMesin.nama_outlet }}</p>
                    </div>
                    <div class="p-x-20">
                        <div class="card_breadcrum p-t-16" v-if="totalSettlementEdc">
                            <SOHeaderList
                                :title="`${totalSettlementEdc}x Settlement`"
                                :show-filter="true"
                                @filter="togleFilter(true)"
                            />
                        </div>
                        <div>
                            <SOCardSettlementEdc :search="search" />
                        </div>
                    </div>
                    <SOLoadMoreLoading :id="'load-more-mesin-edc'" :loading="isLoadMore" />
                    <div v-if="!isFetching && totalSettlementEdc">
                        <SOFABExport @export="openModalExport" />
                    </div>
                </div>
            </template>
            <template v-slot:filter>
                <SOFilter
                    v-if="onFilter"
                    :filter-settlement-edc="true"
                    :sorting="getSorting"
                    @back="togleFilter(false)"
                    @do-filter="doFilter"
                    @reset-filter="resetFilter"
                />
            </template>
            <template v-slot:export-import>
                <div class="vh-100" v-if="isExporting && !isMinExport">
                    <SOExportProgress
                        :context="'Settlement EDC'"
                        :tracker-actions="`${modulName}/exportTracker`"
                        @on-success="checkExport"
                        @on-error="exportFail"
                        @minimized-export="minimizedExport"
                    />
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOHeaderList from "@/so-components/global/ui/SOHeaderList";
import SOSearchBar from "@/so-components/global/ui/SOSearchBar";

import SOLoadSearch from "@/so-components/global/ui/SOLoadSearch";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading";
import SOEmptyState from "@/so-components/global/ui/SOEmptyState";
import SOEmptySearchState from "@/so-components/global/ui/SOEmptySearchState";

import SOFilter from "@/so-components/global/filter/base/SOFilter";
import SOFABExport from "@/so-components/global/ui/SOFABExport";
import SOExportProgress from "@/so-components/global/ui/SOExportProgress";
import SOExportProgressMinimized from "@/so-components/global/ui/SOExportProgressMinimized";
import SOExportMultipleFile from "@/so-components/global/ui/SOExportMultipleFile";

import CardSkeleton from "../components/CardSkeleton.vue";
import SOCardSettlementEdc from "../components/SOCardSettlementEdc.vue";

import { moduleName } from "../store/state";
import sorting from "../static/sortOrderSettlement";

export default {
    name: "SettlementEdcList",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOHeaderList,
        SOSearchBar,
        SOEmptyState,
        SOEmptySearchState,
        SOLoadSearch,
        SOLoadMoreLoading,
        SOFilter,
        SOCardSettlementEdc,
        CardSkeleton,
        SOFABExport,
        SOExportProgress,
        SOExportProgressMinimized,
        SOExportMultipleFile
    },
    data() {
        return {
            search: {
                key: "",
                idedc: this.$route.params.id_mesin,
                searching: false,
                onSearch: false,
            },
            onFilter: false,
        };
    },
    beforeRouteLeave(to, from, next) {
        if (from.name === "mesin.edc.detail.settlement.edc") {
            this.setLastItem();
        }

        if (to.name === "mesin.edc.detail") {
            this.resetDataList();
        }

        next();
    },
    mounted() {
        this.init();
        this.scrollTo();
    },
    computed: {
        ...mapGetters(moduleName, {
            totalSettlementEdc: "totalSettlementEdc",
            listSettlementEdc: "listSettlementEdc",
            isLoadMore: "isLoadMore",
            isFetching: "isFetching",
            displayCard: "displayCard",
            lastSettlementToView: "lastSettlementToView",
            detailMesin: "detailMesin",
            exportData: "exportData",
            exportProgress: "exportProgress",
        }),
        countDataSearch() {
            return this.totalSettlementEdc ? this.totalSettlementEdc : 0;
        },
        getSorting() {
            return sorting;
        },
        modulName() {
            return moduleName;
        },
        isMinExport() {
            return this.exportData.minimized;
        },
        isExporting() {
            return this.exportData.exporting;
        },
        isMultipleExport() {
            return this.exportData.multiple;
        },
        dataExport() {
            return this.exportData.data;
        },
        dataLength() {
            return this.exportData.dataLength;
        },
    },
    methods: {
        ...mapActions({
            getDetailMesin: `${moduleName}/getDetailMesin`,
            getListSettlementEdc: `${moduleName}/getListSettlementEdc`,
            resetPaginationSettlement: `${moduleName}/resetPaginationSettlement`,
            resetListSettlementEdc: `${moduleName}/resetListSettlementEdc`,
            setLastSettlementToView: `${moduleName}/setLastSettlementToView`,
            toggleExporting: `${moduleName}/toggleExporting`,
            setMinimized: `${moduleName}/setMinimized`,
            setMultiple: `${moduleName}/setMultiple`,
            exportTracker: `${moduleName}/exportTracker`,
            setData: `${moduleName}/setData`,
            setDataLength: `${moduleName}/setDataLength`,
            setExportProgress: `${moduleName}/setExportProgress`,
        }),
        async init() {
            if (this.listSettlementEdc.length === 0) {
                await this.resetFilter();
                await this.resetPaginationSettlement();
                await this.getListSettlementEdc(this.search);
            }

            if (!this.detailMesin.idmesin_edc) {
                await this.getDetailMesin(this.$route.params.id_mesin);
            }
        },
        scrollTo() {
            let el = document.getElementById(this.lastSettlementToView.id);

            if (el) {
                setTimeout(() => {
                    el.scrollIntoView();
                    document.documentElement.scrollTop = document.documentElement.scrollTop - 53;
                }, 100);
            }
        },
        setLastItem() {
            let newDP = this.displayCard.sort(function(a, b) {
                if (a.yDir < b.yDir) {
                    return -1;
                }
                if (a.yDir > b.yDir) {
                    return 1;
                }
                return 0;
            });

            if (newDP[0]) {
                this.setLastSettlementToView(newDP[0]);
            }
        },
        back() {
            this.$router.push({ name: "mesin.edc.detail" });
        },
        async resetDataList() {
            await this.resetListSettlementEdc();
        },
        toggleSearch(val) {
            this.search.onSearch = val;
        },
        togleFilter(val) {
            this.onFilter = val;
        },
        onOpenSearch() {
            this.toggleSearch(true);
            this.resetFilter();
            this.resetPaginationSettlement();
            this.resetDataList();
        },
        async onCloseSearch() {
            await this.toggleSearch(false);
            await this.resetPaginationSettlement();
            await this.resetSearchFilter();
            await this.resetDataList();
            await this.init();
        },
        onLoadingSearch(value) {
            this.search.searching = value;
        },
        async doSearch(searchKey) {
            this.search.key = searchKey;
            await this.onLoadingSearch(false);
            await this.resetDataList();
            await this.resetPaginationSettlement();
            await this.getListSettlementEdc(this.search);
        },
        async doFilter() {
            await this.resetPaginationSettlement();
            await this.resetDataList();
            await this.togleFilter(false);
            await this.getListSettlementEdc(this.search);
        },
        resetSearchFilter() {
            this.resetFilter();
            this.search.key = "";
        },
        async resetFilter() {
            await this.$store.commit("filterGlobalModule/resetFilterItem");
            await this.$store.commit("filterGlobalModule/setFilter", JSON.parse(this.getSorting[0].value));
        },
        openModalExport() {
            this.$router.push({
                name: "mesin.edc.detail.settlement.edc.export",
                query: { searchKey: this.search.key },
            });
        },
        async checkExport() {
            this.toggleExporting(false);
            this.setMinimized(false);
            this.setMultiple(false);

            let tracker = await this.exportTracker();
            if (!tracker.success) {
                return;
            }

            this.setDataLength(tracker.data.length);

            if (tracker.data.info_data_export.length > 0) {
                if (tracker.data.status === 1) {
                    this.setMultiple(true);
                    this.setData(tracker.data.info_data_export);
                    if (this.dataExport.length > 0) {
                        this.dataExport.forEach((v) => {
                            v["downloaded"] = false;
                        });
                    }
                } else {
                    this.setMinimized(true);
                }
            }
        },
        exportFail() {
            this.toggleExporting(false);
        },
        minimizedExport(data) {
            this.setMinimized(true);
            this.setExportProgress(data);
        },
        finishExport() {
            this.setMultiple(false);
            this.setData([]);
        },
    },
};
</script>
